/**
 * PAS util
 */

define(function(require) {
    const $ = require('j');
    const { pas } = require('bundle');

    const wrapPromiseToDeferred = (method) => {
        return function() {
            const def = $.Deferred();

            method.apply(pas, arguments)
                .then(def.resolve)
                .catch(error => {
                    def.reject(error);
                });

            return def.promise();
        };
    };

    const pasMethodNames = [
        'login', 'logout', 'getLoggedInPlayer', 'getTempToken', 'setLoginType',

        'initExternalAuth', 'setTerms',
        'changePassword', 'forgotPassword', 'forgotPassToken',
        'loginBankId', 'registrationBankId', 'loginExternalToken', 'validateSessionBankId', 'cancelBankId'
    ];

    let wrappedMethods;

    // check for admin panel
    if (pas) {
        wrappedMethods = pasMethodNames.reduce((acc, methodName) => {
            acc[methodName] = wrapPromiseToDeferred(pas[methodName]);

            return acc;
        }, {});
    }

    return {
        ...pas,
        ...wrappedMethods
    };
});
